var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_911_398",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H22V22H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_911_398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 19.2487C12.7981 19.2476 14.5466 18.6589 15.979 17.572C17.4115 16.4852 18.4495 14.9599 18.9348 13.2285C19.42 11.4971 19.326 9.65456 18.6671 7.98154C18.0081 6.30852 16.8203 4.89677 15.2847 3.96136C13.749 3.02595 11.9497 2.61818 10.1608 2.80016C8.37193 2.98214 6.69157 3.7439 5.37574 4.96939C4.05991 6.19487 3.18075 7.81689 2.87219 9.58834C2.56364 11.3598 2.84261 13.1835 3.6666 14.7817L2.74994 19.2487L7.21685 18.332C8.38622 18.9362 9.68368 19.2506 10.9999 19.2487Z",
    stroke: "#303030",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChats);
export default __webpack_public_path__ + "static/media/chats.c45cf737d9160ad8d21d6fcb925b4910.svg";
export { ForwardRef as ReactComponent };